<template>
  <div>
    <div v-if="loading">
      <vue-element-loading :active="true" :is-full-screen="true" />
    </div>
    <CCard v-if="!loading" style="margin-top: 20px">
      <CCardHeader>
        <h5>
          <b>{{ this.gameName }}</b>
        </h5>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="12">
            <CRow>
              <CCol sm="6">
                <label>Pool Start Date </label>
                <CCard v-if="enablepicker">
                  <CCardHeader>
                    <span>{{ this.editstarttime }}</span>
                    <CButton
                      @click="changepicker()"
                      color="success"
                      style="float: right"
                      >change</CButton
                    >
                  </CCardHeader>
                </CCard>
                <VueCtkDateTimePicker v-model="Poolstarttime" v-else />
                <br />
              </CCol>
              <CCol sm="6" style="margin-top: auto">
                <CCard>
                  <CCardHeader>
                    <span style="font-size: 14px; font-weight: bold"
                      >Contest Enabled</span
                    >

                    <input
                      v-model="isContestEnabled"
                      type="checkbox"
                      value="ContestEnabled"
                      style="float: right; width: 113px; height: 22px"
                    />
                  </CCardHeader>
                </CCard>
              </CCol>

              <CCol sm="6">
                <label>Match Start Time</label>
                <CCard v-if="matchTimeEnablePicker">
                  <CCardHeader>
                    <span>{{ this.editMatchtime }}</span>
                    <CButton
                      @click="matchTimeChangePicker()"
                      color="success"
                      style="float: right"
                      >change</CButton
                    >
                  </CCardHeader>
                </CCard>
                <VueCtkDateTimePicker v-model="MatchStarttime" v-else />
                <br />
              </CCol>
              <CCol sm="6">
                <label>Match End Date </label>
                <CCard v-if="enablepicker">
                  <CCardHeader>
                    <span>{{ this.editendtime }}</span>
                    <CButton
                      @click="changepicker()"
                      color="success"
                      style="float: right"
                      >change</CButton
                    >
                  </CCardHeader>
                </CCard>
                <VueCtkDateTimePicker v-model="PoolEndtime" v-else />
                <br />
              </CCol>
              <!-- <CCol sm="6">
                    <label>Prize</label>
                    <CInput type="number" v-model="price" />
                  </CCol> -->

              <!-- <CCol sm="6">
                    <label>Room ID</label>
                    <CInput v-model="roomID" />
                  </CCol>
                  <CCol sm="6" v-if="this.roomPassword != 'Ludo King'">
                    <label>Room Password</label>
                    <CInput v-model="roomPassword" />
                  </CCol> -->
              <CCol sm="6">
                <label>Tournament Name</label>
                <CInput v-model="tournamentName" type="text" />
              </CCol>
              <CCol sm="6">
                <label>Tournament Prize</label>
                <CInput v-model.number="collectedFee" type="number" />
              </CCol>
              <CCol sm="6">
                <label>Max Winnings</label>
                <CInput v-model.number="maxWinnings" type="number" />
              </CCol>
              <CCol sm="6">
                <label>Minimum Players</label>
                <CInput v-model.number="minimumPlayers" type="number" />
              </CCol>
              <CCol sm="6">
                <label>Maximum Players</label>
                <CInput v-model.number="maximumPlayers" type="number" />
              </CCol>

              <!-- <CCol sm="6">
                  <label>PlatFrom Fee</label>
                  <CInput v-model.number="platformFee" type="number" />
                </CCol> -->
              <CCol sm="12">
                <label>Pool distribution ({{ this.displayFee }}%) </label>
                <div
                  class="form-group"
                  v-for="(input, k) in this.gamePrize"
                  :key="k"
                >
                  <CRow>
                    <CCol sm="6">
                      <input
                        type="number"
                        class="form-control"
                        placeholder="Game Prize"
                        v-model.number="gamePrize[k]"
                      />
                    </CCol>
                    <CCol sm="2">
                      <span>
                        <CButton
                          color="danger"
                          @click="removeGamePrize(k)"
                          v-show="k || (!k && gamePrize.length > 1)"
                        >
                          <i class="fa fa-times"></i
                        ></CButton>
                        &nbsp;&nbsp;&nbsp;
                        <CButton
                          color="success"
                          @click="addGamePrize()"
                          v-show="k == gamePrize.length - 1"
                        >
                          <i class="fa fa-plus" aria-hidden="true"></i
                        ></CButton>
                      </span>
                    </CCol>
                  </CRow>
                </div>
              </CCol>
              <CCol sm="6">
                <label>Token name</label>
                <Vselect :options="options" v-model="tournamentTokenName" />
                <!-- <CInput v-model="tournamentTokenName" type="text" /> -->
              </CCol>
              <CCol sm="6">
                <label>Choose a Network</label>
                <Vselect :options="networks" v-model="selectedNetwork" />
                <!-- <CInput v-model="tournamentTokenName" type="text" /> -->
              </CCol>
              <CCol sm="12" class="mt-3">
                <p>Add Tournament Rules</p>
                <div
                  class="form-group"
                  v-for="(input, k) in this.rules"
                  :key="k"
                >
                  <CRow>
                    <CCol sm="6">
                      <!-- <label>Rage Fees</label> -->
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Rule...."
                        v-model.number="rules[k]"
                      />
                    </CCol>
                    <CCol sm="2">
                      <span>
                        <CButton
                          color="danger"
                          @click="removeRules(k)"
                          v-show="k || (!k && rules.length > 1)"
                        >
                          <i class="fa fa-times"></i
                        ></CButton>
                        &nbsp;&nbsp;&nbsp;
                        <CButton
                          color="success"
                          @click="addRules()"
                          v-show="k == rules.length - 1"
                        >
                          <i class="fa fa-plus" aria-hidden="true"></i
                        ></CButton>
                      </span>
                    </CCol>
                  </CRow>
                </div>
              </CCol>

              <!-- <CCol sm="6"> </CCol> -->
              <br />
              <CCol sm="6">
                <label>Reward Distribution Message</label>
                <CTextarea
                  placeholder="Enter Reward Distribution Message here..."
                  horizontal
                  rows="5"
                  class="w-100"
                  v-model="rewardDistributionmsg"
                />
              </CCol>
              <br />
              <CCol sm="6">
                <label>Winner Message</label>
                <CTextarea
                  placeholder="Enter Winner Message here..."
                  horizontal
                  rows="5"
                  class="w-100"
                  v-model="winnersmsg"
                />
              </CCol>
              <br />
              <CCol sm="12">
                <CCard>
                  <CCardHeader>
                    <CRow>
                      <CCol sm="3"><h5>Choose Field Type</h5> </CCol>
                      <CCol sm="5">
                        <input
                          @change="fieldChange"
                          type="radio"
                          style="width: 57px; height: 21px"
                          v-model="fieldtype"
                          value="RoomIDandPassword"
                        />&nbsp;<span style="font-size: 17px; font-weight: 500"
                          >RoomID and Password
                        </span>
                      </CCol>
                      <CCol sm="4">
                        <input
                          @change="fieldChange"
                          type="radio"
                          v-model="fieldtype"
                          value="RoomID"
                          style="width: 57px; height: 21px"
                        />&nbsp;<span style="font-size: 17px; font-weight: 500"
                          >RoomID</span
                        >
                      </CCol>
                    </CRow>
                  </CCardHeader>
                </CCard>
              </CCol>
              <CCol sm="6">
                <label>Room ID</label>
                <CInput v-model="roomID" />
              </CCol>

              <CCol sm="6" v-if="fieldtype == 'RoomIDandPassword'">
                <label>Room Password</label>
                <CInput v-model="roomPassword" />
              </CCol>
              <CCol sm="12" style="text-align: center !important">
                <br /><br />
                <CButton color="success" style="width: 20%" @click="saveGame()"
                  >Save</CButton
                >
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>
    
    <script>
import firebase from "firebase";
const db = firebase.firestore();
import VueElementLoading from "vue-element-loading";

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import { Vselect } from "@/components";
export default {
  components: { VueCtkDateTimePicker, Vselect, VueElementLoading },
  data() {
    return {
      countmatchId: 1,
      isContestEnabled: false,
      //   isRoomEnabled: false,
      isActive: false,
      GameName: "",
      Limit: 0,
      Poolstarttime: "",
      PoolEndtime: "",
      MatchStarttime: "",
      price: 0,
      roomPassword: "",
      roomID: "",
      id: "",
      enablepicker: false,
      editstarttime: "",
      editendtime: "",
      editMatchtime: "",
      matchTimeEnablePicker: false,
      isPoolUpdate: false,
      isMatchUpdate: false,
      options: [],
      networks: [],
      selectedNetwork: "",
      rageEntrancePrice: 0,
      PrageEntrancePrice: 0,
      gamePrize: [0],
      infoEnableTime: "",
      fieldtype: "RoomIDandPassword",
      isfield: true,
      basePoint: "",
      //   contractAddress: "",
      //   fee: "",
      //   icon: "",
      //   increment: "",
      //   name: "",
      //   tournamentExtraFee: "",
      //   tournamentFee: "",

      PragebasePoint: "",
      contractAddress: "",
      fee: "",
      icon: "",
      increment: "",
      name: "",
      tournamentExtraFee: "",
      tournamentFee: "",
      tokens: null,
      tournamentTokenName: "",
      gameName: "",
      minimumPlayers: "",
      maximumPlayers: "",
      platformFee: 0,
      displayFee: 100,
      rules: [""],
      tournamentName: "",
      gameImage: "",
      gameId: "",
      rewardDistributionmsg: "",
      gameTokens: [],
      winnersmsg: "",
      coverImage: "",
      roomPassword: "",
      roomID: "",
      isRoomTime: "",
      loading: false,
      collectedFee: 0,
      maxWinnings: 0,
      featureCover:""
    };
  },
  watch: {
    platformFee() {
      if (this.platformFee >= 100) {
        this.showMessage("Platform Fee Should be Less Than 100", "warning");
      }
    },
  },
  methods: {
    fieldChange() {
      console.log(this.fieldtype);
    },
    addGamePrize() {
      this.gamePrize.push(0);
    },
    removeRules(index) {
      this.rules.splice(index, 1);
    },
    addRules() {
      this.rules.push("");
    },
    removeGamePrize(index) {
      this.gamePrize.splice(index, 1);
    },
    async GetgameName() {
      try {
        await db
          .collection("htmlGamesTokens")
          .where("chainless", "==", true)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              this.gameTokens.push(doc.data());
              this.options.push(doc.data().name);
              if (!this.networks.includes(doc.data().network)) {
                this.networks.push(doc.data().network);
              }
            });
          });
      } catch (error) {
        console.log("error", error);
      }
    },
    showMessage(msg, icon) {
      Swal.fire({
        position: "center",
        icon: icon,
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    },

    changepicker() {
      this.enablepicker = false;
      this.isPoolUpdate = true;
      this.Poolstarttime = "";
      this.PoolEndtime = "";
    },
    matchTimeChangePicker() {
      this.matchTimeEnablePicker = false;
      this.isMatchUpdate = true;
      this.MatchStarttime = "";
    },
    subtractMinutes(numOfMinutes, date) {
      console.log(typeof date);
      let date1 = new Date(date);
      date1.setMinutes(date1.getMinutes() - numOfMinutes);
      console.log(date1);

      return date1;
    },
    async saveGame() {
      // console.log("isRoomEnabled", this.isRoomEnabled);
      //   this.subtractMinutes(15, this.MatchStarttime);
      let sum = 0;

      let tokenIcon = this.gameTokens.find(
        (e) => e.name == this.tournamentTokenName
      );
      //  console.log("tokenIcon",tokenIcon)
      for (let i = 0; i < this.gamePrize.length; i++) {
        if (this.gamePrize[i] == 0) {
          this.showMessage("pool percentage should not be zero ", "warning");
          return false;
        } else {
          sum += this.gamePrize[i];
        }
      }

      if (this.gamePrize.length <= 0) {
        this.showMessage("please fill pool percentage", "warning");
      } else if (this.Poolstarttime == "") {
        this.showMessage("Choose Pool Start Time", "warning");
      } else if (this.MatchStarttime == "") {
        this.showMessage("Choose Match Start Time", "warning");
      } else if (this.PoolEndtime == "") {
        this.showMessage("Choose Match End Time", "warning");
      }
      // else if (this.rageEntrancePrice == "") {
      //   this.showMessage("Enter Tournament Fee", "warning");
      // }
      else if (this.collectedFee == "") {
        this.showMessage("Enter Tournament Prize", "warning");
      } else if (this.minimumPlayers == "") {
        this.showMessage("Enter Minimum Players", "warning");
      } else if (this.maximumPlayers == "") {
        this.showMessage("Enter Maximum Players", "warning");
      } else if (sum < this.displayFee) {
        this.showMessage(
          "Pool distribution should not be less than " + `${this.displayFee}`,
          "warning"
        );
      } else if (sum > this.displayFee) {
        this.showMessage(
          "Pool distribution should not be greater than " +
            `${this.displayFee}`,
          "warning"
        );
      }
      // else if (this.platformFee == "") {
      //   this.showMessage("Choose Pool Start Time", "warning");
      // }
      else if (this.tournamentName == "") {
        this.showMessage("Enter Tournament Name", "warning");
      } else if (this.tournamentTokenName == "") {
        this.showMessage("Choose a Token for tournament", "warning");
      } else if (this.selectedNetwork == "") {
        this.showMessage("Choose a Network for tournament", "warning");
      } else if (this.rules.some((e) => e == "")) {
        this.showMessage(
          "Some Fields are Missing in Tournament Rules",
          "warning"
        );
      } else if (this.rewardDistributionmsg == "") {
        this.showMessage("Reward Distribution Message is Required", "warning");
      } else if (this.winnersmsg == "") {
        this.showMessage("Winner Message is Required", "warning");
      } else if (this.roomID == "") {
        this.showMessage("Room Id is Required", "warning");
      } else if (
        this.fieldtype == "RoomIDandPassword" &&
        this.roomPassword == ""
      ) {
        this.showMessage("Room Password is Required", "warning");
      } else {
        this.loading = true;
        //   let maxAmount = this.maximumPlayers * this.rageEntrancePrice;
        //   let maxPercent = Math.max(...this.gamePrize);
        //   let maxWinnings = (maxAmount / 100) * maxPercent;
        // this.isActive = true;

        // subract 15 mins in extrapay time for room time
        this.isRoomTime = this.subtractMinutes(15, this.MatchStarttime);
        let data = {
          GameId: this.id,
          GameName: this.gameName,
          startTime: this.Poolstarttime,
          endTime: this.PoolEndtime,
          extrapayTime: this.MatchStarttime,
          isContestEnabled: this.isContestEnabled,
          // tournamentId: this.countmatchId,
          tournamentTokenName: tokenIcon.symbol,
          addRage: this.gamePrize,
          minimumPlayers: this.minimumPlayers,
          maximumPlayers: this.maximumPlayers,
          platformFee: 0,
          tournamentFee: 0,
          tournamentExtraFee: 0,
          rules: this.rules,
          network: this.selectedNetwork,
          tournamentName: this.tournamentName,
          maxWinnings: this.maxWinnings,
          tokenImage: tokenIcon.icon,
          rewardDistributionmsg: this.rewardDistributionmsg,
          winnersmsg: this.winnersmsg,
          isRoomId: this.fieldtype == "RoomID" ? true : false,
          roomId: this.roomID,
          roomPassword: this.roomPassword,
          coverImage: this.coverImage,
          gameImage: this.gameImage,
          isRoomTime: this.isRoomTime,
          collectedFee: this.collectedFee,
          featureCover:this.featureCover,
          isFree: true,
        };
        console.log("data", data);
        try {
          let resp = await axios.post(
            "https://scramble-api.rage.fan/saveEsportsTournament",
            // "http://localhost:5000/saveEsportsTournament",
            // "http://localhost:5000/token-geomine/us-central1/api/saveTournament",
            { ...data }
          );
          this.loading = false;
          console.log("resp", resp);
          console.log("data", data);
          if (resp.data.status == true) {
            this.showMessage("Data Updated Successfully", "success");
            this.$router.push({
              name: "esportsList",
            });

            //   this.$router.push({ name: "tournaments" });
          } else {
            this.showMessage("Couldn't save Esports tournament", "error");

            //   this.$router.push({ name: "tournaments" });
          }
        } catch (error) {
          this.loading = false;
          console.log(error);
        }
      }
    },
    count() {
      db.collection("settings")
        .doc("config")
        .get()
        .then((snapshot) => {
          //   snapshot.forEach((doc) => {
          this.countmatchId = snapshot.data().tournamentCount;

          //   });
          console.log("count", this.countmatchId);
        });
    },
  },
  created() {
    // console.log(" this.$route.params", this.$route.params);
    this.id = this.$route.params.id;
    this.gameName = this.$route.params.gameName;
    this.gameImage = this.$route.params.gameImage;
    this.coverImage = this.$route.params.coverImage;
    this.featureCover = this.$route.params.featureCover;
    // console.log(
    //   "entered created",
    //   this.id,
    //   this.gameName,
    //   this.gameImage,
    //   this.coverImage
    // );
    // this.GetDataByID();
    //   this.count();
    this.GetgameName();
  },
};
</script>
    